/**
 * EndNote Click (formerly Kopernio)
 *
 * Exposes a single static resource. Like Google Translate, that means no corroborating
 * probe is available — one rename and detection stops.
 * Manifest verified against version 3.5.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'fjgncogppolhfdpijihbpfmeohpaadpc';
export const endnoteClick: ExtensionDefinition = {
  id: ID,
  name: 'EndNote Click',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 5_000_000,
  notes: 'Single exposed resource — no second signal available to corroborate.',
  signals: [
    { id: 'war-settings-json', kind: 'web-accessible-resource',
      description: 'Fetch settings.json — the extension\'s only web-accessible resource.',
      weight: 1, run: () => probeFetch(ID, 'settings.json') },
  ],
};
